import React from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useRouteMatch, Switch, Route } from 'react-router'
import AddChequeDetails from '../AddChequeDetails'
import RlpApplication from './RlpApplication'
import RlpReturn from './RlpReturn'

const Rlp = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="gpc">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              <Nav.Item className="custom-nav-item">
                <Nav.Link eventKey="gpc">RLP Applications</Nav.Link>
              </Nav.Item>
              <Nav.Item className="custom-nav-item">
                <Nav.Link eventKey="gpc-return">RLP Return</Nav.Link>
              </Nav.Item>
            </Nav>
          </Row>
          <Row className="page-tiles-layout">
            <Tab.Content>
              <Tab.Pane eventKey="gpc">
                <RlpApplication />
              </Tab.Pane>
              <Tab.Pane eventKey="gpc-return">
                <RlpReturn />
              </Tab.Pane>
            </Tab.Content>
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/add/:id`}
        render={(props) => <AddChequeDetails scheme={'RLP'} {...props} />}
      />
    </Switch>
  )
}

export default Rlp
